// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCheckmark_root__2iiXs"};